import React, { PureComponent } from 'react';
import { Item, Icon, Label } from 'semantic-ui-react';
import Link from 'comps/link';

export default class PersonalDetails extends PureComponent {
  render() {
    const { data } = this.props;
    return (
      <Item>
        <Item.Content>
          <Item.Header as="h4">
            <Link
              to={{
                pathname: '/teacher/' + data._id,
                teacherName: data.name,
                teacherData: data,
              }}
              target="_blank"
            >
              {data.name}{' '}
            </Link>
          </Item.Header>

          <Item.Meta>
            <a href={'mailto:' + data.email}>
              <Icon name="mail outline" />
            </a>{' '}
            | {data.phone}
          </Item.Meta>
          <Item.Meta>
            <Label
              basic
              content={data.student_region ? data.student_region : 'NA'}
              color="black"
            />
            <Label
              basic
              content={data.student_personality ? data.student_personality : 'NA'}
              color="black"
            />
            <Label
              basic
              content={data.student_competence ? data.student_competence : 'NA'}
              color="black"
            />
          </Item.Meta>
        </Item.Content>
      </Item>
    );
  }
}
